import cn from 'classnames';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/redux/createAction';
import { actionsAuth } from 'src/pages/SignInPage/_BLL/slice';
import { Logo } from 'src/shared/ui/Logo/Logo';
import { HeaderProfile } from '../HeaderProfile/HeaderProfile';
import s from './HeaderNew.module.scss';
import { FC } from 'react';
import { routerPath } from 'src/app/router/ui/AppRouter';

export const HeaderNew: FC = () => {
	// * Actions
	const handleLogout = () => dispatch(logout());

	// * Actions
	const dispatch = useAppDispatch();
	const { logout } = actionsAuth;

	// * Selectors
	const userData = useAppSelector((state) => state.auth.userData);

	// * Render
	return (
		<header className={s.container}>
			{/* First row */}
			<div className={s.row_first}>{userData && <HeaderProfile />}</div>

			{/* Separate line */}
			<div className={s.line}></div>

			{/* Second row */}
			<div className={s.row_second}>
				<Logo
					className={s.logo}
					line={false}
					href={routerPath.mainPage}
				/>

				{userData && (
					<div
						className={cn(s.rightCorner, s.user)}
						onClick={handleLogout}
					>
						Log Out
					</div>
				)}
			</div>
		</header>
	);
};
